import React from 'react'
import { Button, Modal } from 'react-bootstrap';

const ModalCursoGastroenterologia = ({ toggleFunction, modalState }) => {
  const formLink = 'https://forms.gle/3cZFKBZcPYbmXDnb7'

  return (
    <Modal show={modalState} onHide={() => toggleFunction(false)} dialogClassName='custom-lg'>
      <Modal.Header closeButton>
        <Modal.Title>Curso de Gastroenterología, Hepatología y Nutrición</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className='info-container cupos-container cards-center text-center'>
          <p hidden className='heading-title fw-semibold mb-4'></p>

          <div className='info-group mb-3'>
            <p className='heading-title-md fw-semibold mb-2'>Inscripciones</p>
            <p className='fw-normal'>Desde el 24/02 hasta el 20/03 de 2026</p>
          </div>
          <div className='info-group mb-3'>
            <p className='heading-title-md fw-semibold mb-2'>Fecha de Inicio</p>
            <p className='fw-normal'>Sábado 21 de marzo de 2026</p>
          </div>
          <div className='info-group mb-3'>
            <p className='heading-title-md fw-semibold mb-2'>Horario</p>
            <p className='fw-normal'>Sábados de 8:00 AM a 12:00 PM</p>
          </div>

          <a className='btn btn-primary link-button mb-4' href={formLink} target='blank'>
            Formulario de Inscripción
          </a>

          <div className='info-group mt-3 mb-1'>
            <p className='fw-semibold mb-0'>Dr. Freddy Pachano Arenas</p>
            <p className='fw-semibold mb-3'>Director</p>

            <p className='fw-semibold mb-0'>Dra. Gisela Romero</p>
            <p className='fw-semibold mb-0'>Coordinadora</p>
          </div>
        </section>
      </Modal.Body>
      <Modal.Footer>
        <Button className='footer-button' variant="secondary" onClick={()=> toggleFunction(false)}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export { ModalCursoGastroenterologia }